const wrappedCatch = (fn) => (err) => {
    if (err.name !== 'AbortError') {
        return fn()
    }

    return undefined
}

const wrappedCancelled = (fn) => (err) => {
    if (err.name === 'AbortError') {
        return fn()
    }

    return undefined
}

const rethrow = (fn) => (err) => {
    fn()
    throw err
}

export const CancellablePromise = (inflight, controller) => ({
    then: (onFulfilled, onRejected) =>
        CancellablePromise(inflight.then(onFulfilled, onRejected), controller),

    catch: (onRejected) => CancellablePromise(inflight.catch(wrappedCatch(onRejected)), controller),

    cancelled: (onCancelled) =>
        CancellablePromise(inflight.catch(wrappedCancelled(onCancelled)), controller),

    finally: (onComplete) =>
        CancellablePromise(inflight.then(onComplete).catch(rethrow(onComplete)), controller),

    cancel: () => controller.abort(),
})
